import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
    {
      id: 'gdpr',
      name: 'GDPR Compliant',
      icon: 'Shield',
      description: 'EU General Data Protection Regulation certified'
    },
    {
      id: 'iso27001',
      name: 'ISO 27001',
      icon: 'Award',
      description: 'Information Security Management certified'
    },
    {
      id: 'eu-hosting',
      name: 'EU Hosting',
      icon: 'Server',
      description: 'Data hosted exclusively in EU regions'
    },
    {
      id: 'soc2',
      name: 'SOC 2 Type II',
      icon: 'CheckCircle',
      description: 'Security and availability controls verified'
    }
  ];

  const securityFeatures = [
    'End-to-end encryption',
    'Multi-factor authentication',
    'Regular security audits',
    'Zero-trust architecture'
  ];

  return (
    <div className="w-full space-y-8">
      {/* Certifications */}
      <div className="text-center">
        <h3 className="text-sm font-medium text-foreground mb-4">
          Enterprise-grade infrastructure
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {certifications?.map((cert) => (
            <div
              key={cert?.id}
              className="flex flex-col items-center p-3 bg-card border border-border rounded-lg hover:shadow-soft transition-smooth"
            >
              <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center mb-2">
                <Icon name={cert?.icon} size={16} className="text-primary" />
              </div>
              <span className="text-xs font-medium text-foreground text-center">
                {cert?.name}
              </span>
              <span className="text-xs text-muted-foreground text-center mt-1">
                {cert?.description}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* Security Features */}
      <div className="bg-muted/50 rounded-lg p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Lock" size={16} className="text-primary" />
          <h4 className="text-sm font-medium text-foreground">
            Enterprise Security Standards
          </h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {securityFeatures?.map((feature, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={12} className="text-success" />
              <span className="text-xs text-muted-foreground">{feature}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Support Information */}
      <div className="text-center space-y-2">
        <p className="text-xs text-muted-foreground">
          Any questions?
        </p>
        <div className="flex items-center justify-center space-x-4 text-xs">
          <button className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-smooth">
            <Icon name="Mail" size={12} />
            <span>support@clearequal.com</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;